"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoaderContextProvider = exports.useLoader = void 0;
var _react = _interopRequireWildcard(require("react"));
var _router = _interopRequireDefault(require("next/router"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
var __jsx = _react["default"].createElement;
var LoaderContext = /*#__PURE__*/_react["default"].createContext(false);
var LoaderContextProvider = function LoaderContextProvider(props) {
  var _useState = (0, _react.useState)(false),
    isLoading = _useState[0],
    setLoading = _useState[1];
  var _useState2 = (0, _react.useState)(false),
    submenuLoaded = _useState2[0],
    setSubmenuLoaded = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    cookieNoticeLoaded = _useState3[0],
    setCookieNoticeLoaded = _useState3[1];
  var _useState4 = (0, _react.useState)(props.externalContentTimeout),
    externalContentTimeout = _useState4[0],
    setExternalContentTimeout = _useState4[1];
  (0, _react.useEffect)(function () {
    var handlerComplete = function handlerComplete() {
      return setLoading(false);
    };
    var handlerStart = function handlerStart() {
      return setLoading(true);
    };
    _router["default"].events.on("routeChangeStart", handlerStart);
    _router["default"].events.on("routeChangeComplete", handlerComplete);
    return function () {
      _router["default"].events.off("routeChangeStart", handlerStart);
      _router["default"].events.off("routeChangeComplete", handlerComplete);
    };
  }, []);
  return __jsx(LoaderContext.Provider, {
    value: {
      isLoading: isLoading,
      externalContentTimeout: externalContentTimeout,
      setExternalContentTimeout: setExternalContentTimeout,
      submenuLoaded: submenuLoaded,
      setSubmenuLoaded: setSubmenuLoaded,
      cookieNoticeLoaded: cookieNoticeLoaded,
      setCookieNoticeLoaded: setCookieNoticeLoaded
    }
  }, props.children);
};
exports.LoaderContextProvider = LoaderContextProvider;
var useLoader = function useLoader() {
  return (0, _react.useContext)(LoaderContext);
};
exports.useLoader = useLoader;